import React from 'react';
import cn from 'classnames';
import styles from './Card.module.css';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';

const CardComponent = props => {
  const { title, key, id, children, imgURL, onClick, label, vehicle, userPage, transportOrderPage, transporterPage } = props;
  console.log(vehicle + 'vehicle');
  return (
    <div
      className={cn('card', styles.card)}
      key={key}
      id={id}
      vehicle={vehicle}
      onClick={onClick} // Attach the onClick event handler to the outer div
      role="button" // For accessibility, indicate it's clickable
      tabIndex={0} // Makes the div focusable for keyboard navigation
    >
      <div className={cn('card-subtitle', 'text-muted', styles.cardTitle)}>{title}</div>
      <>
        <div className={styles.label}>{label}</div>
        {!userPage && !transportOrderPage && !transporterPage && (
          <div className={styles.avatarContainer}>
            <VehicleAvatar vehicle={vehicle} location1={'overviewCard'} />
          </div>
        )}
      </>
      <div className="card-body">{children}</div>
    </div>
  );
};

export default CardComponent;
